import moment from 'moment-timezone';
import AuthService from 'library/authService/auth-service';
import { setNewRelicUserAttributes } from 'library/newrelic-utils';
import settings from 'settings';

const SiteSecurity = ({ children }) => {
  if (!AuthService.isAuthenticated()) {
    // -- User is not authenticated.
    // -- Redirect to login page
    // ---
    AuthService.redirectToLogin();
    return null;
  }
  const user = AuthService.whoami();
  if (!user) {
    // -- User is authenticated but user details not found.
    // -- Redirect to tenancy url
    // ---
    AuthService.redirectToTenancy();
    return null;
  }

  // Initialize New Relic with user ID on first secure page load
  if (!window.newRelicInitialized) {
    if (settings.APP_CONFIG.new_relic_browser_license_key && settings.APP_CONFIG.new_relic_browser_application_id) {
      try {
        // Dynamic import to avoid loading in test environment
        // eslint-disable-next-line global-require
        const { BrowserAgent } = require('@newrelic/browser-agent');

        new BrowserAgent({
          info: {
            applicationID: settings.APP_CONFIG.new_relic_browser_application_id,
            licenseKey: settings.APP_CONFIG.new_relic_browser_license_key,
            beacon: settings.APP_CONFIG.new_relic_browser_beacon || 'bam.nr-data.net',
            errorBeacon: settings.APP_CONFIG.new_relic_browser_beacon || 'bam.nr-data.net',
            sa: 1,
          },
          init: {
            session_replay: { enabled: true },
            session_trace: { enabled: true },
            distributed_tracing: { enabled: true },
            ajax: { deny_list: ['bam.nr-data.net'] },
          },
          loader_config: {
            accountID: settings.APP_CONFIG.new_relic_browser_account_id,
            agentID: settings.APP_CONFIG.new_relic_browser_application_id,
            applicationID: settings.APP_CONFIG.new_relic_browser_application_id,
            licenseKey: settings.APP_CONFIG.new_relic_browser_license_key,
            trustKey: settings.APP_CONFIG.new_relic_browser_trust_key,
          },
          exposed: true,
        });

        window.newRelicInitialized = true;
      }
      catch (e) {
        console.warn('[SiteSecurity] Failed to initialize New Relic:', e);
      }
    }
  }

  // Set New Relic user attributes for tracking on each mount
  setNewRelicUserAttributes(user);

  // -- Set the default timezone based on the current tenancy
  // ---
  if (user.currentTenancy) {
    const { timezone } = user.currentTenancy;
    moment.tz.setDefault(timezone);
  }

  // -- User is authenticated and user details exists.
  // -- Load page
  // ---
  return children;
};

export default SiteSecurity;
